import { parsePhoneNumber } from "awesome-phonenumber";

import { Input } from "@/components/ui/input/input";

const formatUSPhone = (digits: string) => {
  if (digits.length === 0) return "";
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

export const PhoneInput = ({
  value,
  onChange,
  ...props
}: React.ComponentProps<typeof Input>) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;

    if (raw?.[0] === "+") {
      onChange?.(e);
      return;
    }

    const digits = raw.replace(/\D/g, "").slice(0, 10);
    const formatted = formatUSPhone(digits);

    const syntheticEvent = {
      ...e,
      target: { ...e.target, value: formatted },
    };

    onChange?.(syntheticEvent as React.ChangeEvent<HTMLInputElement>);
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const pasted = e.clipboardData.getData("text");
    const digits = pasted.replace(/\D/g, "");

    let usDigits: string | null = null;

    if (pasted.startsWith("+")) {
      const parsed = parsePhoneNumber(pasted);
      if (parsed?.valid && parsed.regionCode === "US") {
        usDigits = digits.slice(-10);
      }
    } else if (digits.length === 11 && digits[0] === "1") {
      usDigits = digits.slice(1);
    }

    if (usDigits === null) return;

    e.preventDefault();
    const formatted = formatUSPhone(usDigits);

    const syntheticEvent = {
      ...e,
      target: { ...e.target, value: formatted },
    } as unknown as React.ChangeEvent<HTMLInputElement>;

    onChange?.(syntheticEvent);
  };

  return (
    <Input
      value={value}
      onChange={handleChange}
      onPaste={handlePaste}
      maxLength={100}
      {...props}
    />
  );
};
